import { SrOrderStatus } from '@plato/data/starrocks/types';
import { generateSearchParamsForExplorer } from '../features/explorer/hooks/use-explorer-query-params.ts';
import type { QuoteOrderQueryFilters } from '../features/quote-order-list/hooks/use-quote-order-list-filters.tsx';
import {
    billedOrdersFilter,
    generateSearchParamsForQuotesOrders,
    openOrdersFilter,
    openQuotesFilter,
} from '../features/quote-order-list/hooks/use-quote-order-list-filters.tsx';
import { QuotesOrdersSortBy, SortOrder } from '../server/types/list-view-types.ts';
import {
    BillingStatus,
    ExplorerSortBy,
    ExplorerSortOrder,
    ExplorerTopLevelEntity,
    TargetUnit,
    VisibilityWindow,
} from '../server/utils/explorer-utils.ts';

export function generateSearchParamsForOpenOrders(params: Partial<QuoteOrderQueryFilters>) {
    return generateSearchParamsForQuotesOrders({ ...openOrdersFilter, ...params });
}

export function generateSearchParamsForOpenQuotes() {
    return generateSearchParamsForQuotesOrders(openQuotesFilter);
}

export function generateSearchParamsForAllTransactions() {
    return generateSearchParamsForQuotesOrders({
        orderStatus: [
            SrOrderStatus.OPEN,
            SrOrderStatus.OPEN_IN_PICKING,
            SrOrderStatus.PARTIALLY_BILLED,
            SrOrderStatus.BILLED,
            SrOrderStatus.PARTIALLY_RECEIVED,
            SrOrderStatus.RECEIVED,
        ],
        sortingFilter: {
            field: QuotesOrdersSortBy.ORDER_CREATED_AT_DATE,
            direction: SortOrder.DESC,
        },
    });
}

export function generateSearchParamsForBilledTransactions() {
    return generateSearchParamsForQuotesOrders({
        ...billedOrdersFilter,
    });
}

export function generateSearchParamsForCustomerInsightsNormalisedCategory(
    categoryId: string,
    categoryName: string,
) {
    return generateSearchParamsForExplorer({
        tab: ExplorerTopLevelEntity.NORMALISED_CATEGORY,
        window: VisibilityWindow.TTM,
        normalisedCategory: [categoryId],
        searchStringNormalisedCategory: categoryName,
        targetUnit: TargetUnit.REVENUE,
        billing: BillingStatus.BILLED,
        sorting: {
            field: ExplorerSortBy.REVENUE_CURRENT,
            direction: ExplorerSortOrder.DESC,
        },
        yearPeriods: 2,
    });
}
